import { getToken, setToken, getRefreshToken, setRefreshToken, getTokenExpires, setTokenExpires, removeAuth } from '@/uitils/auth'

const user = {
  namespaced: true,
  state: {
    token: getToken(),
    refreshToken: getRefreshToken(),
    tokenExpires: getTokenExpires(),
  },
  mutations: {
    SET_TOKEN: (state: any, data: any) => {
      const tokenType = data.token_type
      const accessToken = data.access_token
      const token = tokenType + ' ' + accessToken
      setToken(token, (data.expires_in - 1) / (24 * 60 * 60))
      state.token = token
    },
    SET_TOKEN_EXPIRES: (state: any, data: any) => {
      const currentTimestamp = new Date().getTime()
      const timestamp = (currentTimestamp + data * 1000 - 1000).toFixed(0)
      setTokenExpires(timestamp)
      state.tokenExpires = timestamp
    },
    SET_REFRESH_TOKEN: (state: any, data: any) => {
      setRefreshToken(data)
      state.refreshToken = data
    },
  }
}
export default user